export function fileToObject(file: File): Promise<Record<string, unknown>> {
  const reader = new FileReader();
  reader.readAsText(file);

  return new Promise((resolve, reject) => {
    reader.onloadend = (e) => {
      const json = e.target?.result;

      try {
        resolve(JSON.parse(json as string) as Record<string, unknown>);
      } catch {
        reject('Invalid file');
      }
    };
  });
}
